const dev = {
    API_ENDPOINT_URL: 'http://localhost:3001/api/',
    FILES_URL: 'http://localhost:3001/'
};

const prod = {
    API_ENDPOINT_URL: '/api/',     // relative path
    FILES_URL: '/uploads/'         // relative path
};

const test = {
    API_ENDPOINT_URL: '',
    FILES_URL: '',
};

const getEnv = () => {
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev;
        case 'production':
            return prod;
        case 'test':
            return test;
        default:
            break;
    }
};

export const env = getEnv();
